(ns shared.core.amelia-light.components.tag
  (:require ["@up/extended-ui/components/tag" :default Tag]))

(defn up-tag [args]
  [:> Tag args])
